import Auth from '@/services/authenticationService'
import Pages from './data/pages'
export default {
  namespaced: true,
  state: {
    possibleTopLevelPages: Pages.topLevelPages,
    possibleMinorPages: Pages.minorPages,
    topLevelPages: [],
    minorPages: [],
    pages: Pages.pages,
    snackbarText: "",
    snackbarState: false,
    snackbarColor: "blue"

  },
  mutations: {
    // setLoading(state, bool) {
    //     state.loading = bool;
    // }
    modifySnackbarState(state, bool) {
      state.snackbarState = bool;
    },
    setState(state, payload) {
      //console.log(payload.prop + " state set")
      state[payload.prop] = payload.value;
    },
    modifySnackbarText(state, text) {
      state.snackbarText = text;
    },
    modifySnackbarColor(state, color) {
      state.snackbarColor = color;
    }
  },
  actions: {
    displaySnackbar(context, payload) {
      context.commit('modifySnackbarText', payload.text);
      context.commit('modifySnackbarColor', payload.color);
      context.commit('modifySnackbarState', true);
    }
  },
  getters: {
    //getAuthenticated: state => state.authenticated,
  }
}